export default __webpack_public_path__ + "static/media/nightclub-queue.bd4fe83d.jpeg";